import "./BackToTopComponent.scss"
import { useState, useEffect } from "react";
import pagSu from "../../assests/su.png";

/**
 * @function BackToTopComponent BackToTop components
 * @param info information that arrives procedurally provided
 * @returns {JSX.Element}
*/
const BackToTopComponent = () => {
    const [showTopBtn, setShowTopBtn] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 100) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        });
    }, []);

    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    
    return (
        <a onClick={() => goToTop()} aria-hidden="true" tabIndex="-1"  className= {`back-to-top  ${showTopBtn ? "back-to-top-show" : ""}`}  style={{ padding:"0" }}>
            <img src={ pagSu } className="BackToTop" alt={ "Torna su" }></img>
        </a>
    )
};

export default BackToTopComponent;